<template>
  <div class="tenant-admin">
    <breadCrumb></breadCrumb>
    <div class="tenant-admin-header">
      <button @click="addTenant">+新增</button>
    </div>
    <div class="tenant-admin-table">
      <base-table
        :tableData="tableData"
        @handleClick="handleClick"
      ></base-table>
    </div>

    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    >
    </pagination>

    <modal
      :isShow.sync="ifdialogFormVisible"
      :isShowClose="true"
      :title="dialogTitle"
      :btnText="butText"
      :types="types"
      :isShowBtn="isShowBtn"
      @clickHandler="clickHandler"
    >
      <el-form
        :model="formData"
        label-position="right"
        label-width="100px"
        class="form"
        :rules="rules"
        ref="formData"
      >
        <el-form-item label="管理员账号" prop="pin">
          <el-input
            v-model="formData.pin"
            class="dialogInput"
            placeholder="请输入管理员账号"
            size="small"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="账号类型" prop="pinType">
          <el-select
            v-model="formData.pinType"
            class="dialogInput"
            placeholder="请选择账号类型"
            size="small"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </modal>
    <modal
      :isShow.sync="dialogFormVisible"
      :isShowClose="true"
      :title="dialogTitle"
      :btnText="butText"
      :types="types"
      :isShowBtn="isShowBtn"
      @clickHandler="cancelAdmin"
    >
      <div class="dialogVal">确定取消{{ dialogName }}的管理员权限？</div>
    </modal>
  </div>
</template>

<script>
import pagination from "../../../../components/pagination";
import baseTable from "../../../../components/baseTable";
// import newRoleDialog from "../../components/newRoleDialog";
import {
  tenantManagerPage,
  tenantManagerFreeze,
  tenantManagerAdd,
} from "../../../../api/admin";
import modal from "../../../../components/modal";
import breadCrumb from "../../../../components/breadCrumb";
export default {
  name: "tenantManagement",
  components: {
    baseTable,
    // newRoleDialog,
    modal,
    pagination,
    breadCrumb,
  },
  watch: {
    "formData.pin"(newValue, oldValue) {
      //
      if (this.$utils.specialCharacters(newValue)) {
        this.$message({
          message: "禁止输入特殊字符",
          type: "warning",
        });
        this.formData.pin = this.$utils.removalSpace(newValue);
      }
    },
  },
  data() {
    return {
      rules: {
        pin: [{ required: true, message: "请输入管理员账号", trigger: "blur" }],
        pinType: [
          { required: true, message: "请选择账号类型", trigger: "blur" },
        ],
      },
      dialogName: "",
      butText: ["取消", "确定"],
      types: ["default", "submit"],
      isShowBtn: [true, true],
      selectList: [],
      options: [
        {
          label: "erp账号",
          value: 1,
        },
        {
          label: "jd账号",
          value: 2,
        },
        {
          label: "其他账号",
          value: 3,
        },
      ],
      formData: {
        tenementName: "",
        tenementType: "",
        pin: "",
        pinType: 1,
      },
      dialogTitle: "新增管理员",
      labelWidth: "80px",
      width: "400px",
      ifdialogFormVisible: false,

      tableData: {
        tableList: [],
        tableHeader: [
          {
            prop: "id",
            label: "账号ID",
          },
          {
            prop: "pin",
            label: "管理员账号",
          },
          {
            prop: "tenantType",
            label: "所属租户",
          },
          {
            prop: "pinType",
            label: "账号类型",
          },
          {
            prop: "createTime",
            label: "创建时间",
          },
          {
            prop: "updateUser",
            label: "创建人",
          },
        ],
        tableType: 1,
      },
      dialogFormVisible: false,
      val: {},
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.tenantManagerPage(this.$route.query);
  },
  methods: {
    cancelAdmin(val) {
      if (val === "one") {
        this.dialogFormVisible = false;
      } else {
        this.tenantManagerFreeze(this.val.id, this.val.tenantId);
        this.dialogFormVisible = false;
      }
    },
    handleClick(val) {
      this.dialogName = val.val.pin;
      this.dialogFormVisible = true;
      this.val = val.val;
    },
    clickHandler(val) {
      if (val === "one") {
        this.ifdialogFormVisible = false;
      } else {
        this.$refs.formData.validate((valid) => {
          if (valid) {
            this.tenantManagerAdd(
              this.formData.pin,
              this.$route.query.id,
              this.formData.pinType
            );
            this.ifdialogFormVisible = false;
          } else {
            return false;
          }
        });
      }
    },
    addTenant() {
      this.formData.pin = "";

      this.ifdialogFormVisible = true;
    },
    changeDialog() {
      this.dialogFormVisible = false;
    },

    tenantManagerFreeze(val) {
      tenantManagerFreeze({
        id: val,
        tenantId: this.$route.query.id,
      }).then((res) => {
        if (res.msg === "OK") {
          this.tenantManagerPage(this.$route.query);
        }
      });
    },
    tenantManagerAdd(val, id, type) {
      tenantManagerAdd({
        pinType: type, //
        pin: val,
        tenantId: id,
        name: "",
      })
        .then((res) => {
          this.tenantManagerPage(this.$route.query);
        })
        .catch((err) => {
          if (err.code === "1407") {
            this.$message.error("同一账号不能重复添加");
          }
        });
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.tenantManagerPage();
    },
    tenantManagerPage(val) {
      let vm = this;
      tenantManagerPage({
        page: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        tenantId: this.$route.query.id,
      })
        .then((res) => {
          vm.tableData.tableList.splice(0, vm.tableData.tableList.length);
          res.data.map((item) => {
            item.tenantType = this.$route.query.tenantType;
            vm.tableData.tableList.push(item);
          });
          vm.paginationDataProduct.total = res.totalCount;
          vm.paginationDataProduct.currentPage = res.pageNo;
          vm.paginationDataProduct.pageSize = res.pageSize;
        })
        .catch((err) => {
          if (err.code === "1407") {
            this.$message.error(err.msg);
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.dialogInput {
  width: 240px;
}
.dialogVal {
  color: #5f5f6b;
  font-size: 16px;
  padding: 30px 0px;
  padding-bottom: 0px;
  text-align: center;
}
.tenant-admin {
}
.form.el-form.form.el-form--label-right {
  padding-left: 30px;
  margin-top: 30px;
  // padding-right: 40px;
}
:deep(.el-textarea) {
  width: 240px;
  // height: 32px;
}
.el-form :deep(.el-form-item) {
  padding: 5px;
}
:deep(.el-dialog__header) {
  width: 400px;
  height: 46px;
  background: rgba(247, 248, 251, 1);
  border-radius: 4px 4px 0px 0px;

  // width: 32px;
  // height: 22px;
  line-height: 22px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: rgba(51, 56, 64, 1);
  padding: 0;
}
:deep(.el-pagination__editor .is-in-pagination) {
  width: 46px !important;
}
</style>
